import styled from 'styled-components';

const AuthFooter = styled.div`
  text-align: center;

  font-family: 'CircularStd-Bold';
  font-size: 12px;

  a {
    color: #1d4ed8;
  }
`;

export default AuthFooter;
